import { render, staticRenderFns } from "./ManageThemes.vue?vue&type=template&id=09053020"
import script from "./ManageThemes.vue?vue&type=script&lang=ts"
export * from "./ManageThemes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports